import React from 'react'
import image from '../backdrop.jpg'

const Home = () => {
	return (
		<main>
			<img
				src={image}
				alt='leaves'
				className='absolute object-cover max-h-screen w-full h-full'
			/>
			<section className='relative flex items-center justify-center min-h-screen'>
				<div className='relative bg-black bg-opacity-50 w-full min-h-screen'>
					<h1 className='text-6xl lg:text-8xl flex justify-center text-center pt-64 sm:pt-32 text-secondary-600 font-bold cursive'>
						Hello, I'm Sara.
					</h1>
				</div>
			</section>
		</main>
	)
}

export default Home
